import { useState } from "react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import HowItWorks from "@/components/landing/HowItWorks";
import CostBreakdown from "@/components/landing/CostBreakdown";
import WhyCIF from "@/components/landing/WhyCIF";
import WorkspaceIntegration from "@/components/landing/WorkspaceIntegration";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import LeadDialog from "@/components/landing/LeadDialog";

const EstimatedCIFPage = () => {
  const [leadOpen, setLeadOpen] = useState(false);
  const [intent, setIntent] = useState("create-workspace");

  const openWorkspace = () => {
    setIntent("create-workspace");
    setLeadOpen(true);
  };

  const openEstimate = () => {
    // smooth scroll to hero calculator
    const el = document.getElementById("hero-calc");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div className="min-h-screen bg-white text-slate-900 font-body antialiased">
      <Nav onWorkspaceClick={openWorkspace} />
      <main>
        <Hero onEstimateClick={openEstimate} onWorkspaceClick={openWorkspace} />
        <Problem />
        <HowItWorks />
        <CostBreakdown />
        <WhyCIF />
        <WorkspaceIntegration />
        <FAQ />
        <FinalCTA onEstimateClick={openEstimate} onWorkspaceClick={openWorkspace} />
      </main>
      <Footer />
      <LeadDialog open={leadOpen} onOpenChange={setLeadOpen} intent={intent} />
    </div>
  );
};

export default EstimatedCIFPage;
